module.exports = __webpack_public_path__ + "static/media/background.d1121140.png";